import { getCookieProperties } from '../../shared/getCookieProperties';
import { DEVICE_COOKIE_NAME } from '../../shared/const';
import { generateUUID } from './generateUUID';
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[2]) : undefined;
};
export const createCookie = (cookieValue) => {
    if (typeof window === 'undefined' || !window.document) {
        return;
    }
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    const { domain, secure } = getCookieProperties(window.location.hostname);
    const s = secure ? `; secure` : '';
    const d = domain ? `; domain=${domain}` : '';
    document.cookie = `${DEVICE_COOKIE_NAME}=${cookieValue}; path=/; expires=${expiryDate.toUTCString()} ${s} ${d}`;
};
const getAmpId = () => {
    const ampCookieValue = document.cookie
        .split(';')
        .map((s) => s.trim())
        .find((c) => c.startsWith('AMP') && !c.startsWith('AMP_MKTG'));
    if (ampCookieValue) {
        try {
            const encodedValue = ampCookieValue.split('=')[1];
            if (encodedValue) {
                const decoding = Buffer.from(encodedValue, 'base64').toString('utf-8');
                const { deviceId } = JSON.parse(decodeURIComponent(decoding)) || {};
                if (deviceId && typeof deviceId === 'string') {
                    return deviceId;
                }
            }
        }
        catch (error) {
            //
        }
    }
    return undefined;
};
export const getExistingDeviceId = () => getCookie(DEVICE_COOKIE_NAME);
export const getAndSetDeviceId = () => {
    const id = getExistingDeviceId() || getAmpId() || generateUUID();
    createCookie(id);
    return id;
};
